import React from 'react';
import { Dialog } from '@headlessui/react';
import { TWModal } from '../../../../components/ui';
import FinButton from '../../../connect/finance/fin-button';

// The discard and archive confirms (spec §2.7). TWConfirmModal is slate;
// this one is the Finance palette on the same TWModal. It is rendered
// inside the campaign modal's own tree, so headlessui stacks it as a
// nested dialog (an outside click or Escape closes only this one).
// The wording is the designer's brief (new.discard.* / edit.discard.*).
export const NEW_DISCARD_COPY = {
  title: 'Discard this campaign?',
  body: 'Your changes won’t be saved.',
  confirm: 'Discard',
  cancel: 'Keep editing',
};

export const EDIT_DISCARD_COPY = {
  title: 'Discard your changes?',
  body: 'Your changes to this campaign won’t be saved.',
  confirm: 'Discard',
  cancel: 'Keep editing',
};

const ConfirmDialog = ({ open, title, body, confirmLabel, cancelLabel = 'Cancel', danger = false, busy = false, onConfirm, onCancel }) => (
  <TWModal open={open} onClose={busy ? () => {} : onCancel} size="sm" bodyClassName="!p-0">
    <div className="rounded-t-2xl bg-fin-surface px-5 py-5 sm:rounded-md">
      <Dialog.Title as="h3" className="text-[15px] font-bold text-fin-ink">
        {title}
      </Dialog.Title>
      {body ? <Dialog.Description className="mt-1.5 text-[13.5px] leading-relaxed text-fin-muted">{body}</Dialog.Description> : null}
      <div className="mt-5 flex flex-wrap justify-end gap-2">
        <FinButton disabled={busy} onClick={onCancel}>
          {cancelLabel}
        </FinButton>
        {danger ? (
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-lg bg-fin-red px-4 py-2.5 text-[13.5px] font-semibold text-fin-surface hover:bg-fin-red/90 disabled:opacity-60"
          >
            {confirmLabel}
          </button>
        ) : (
          <FinButton variant="primary" disabled={busy} onClick={onConfirm}>
            {confirmLabel}
          </FinButton>
        )}
      </div>
    </div>
  </TWModal>
);

export default ConfirmDialog;
